import logo from "../assets/logo.png";

export default function Hero({ src }) {
  return (
    <div className="relative h-[400px] w-full">
      <img src={src} alt="Mangitalia" className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-black/40 flex flex-col items-center justify-center">
        <img src={logo} alt="Logo Mangitalia" className="mb-4 w-24 h-24 object-contain" />
        <h1 className="text-4xl font-bold text-white text-center">Mangitalia: Qualità, Territorio, Persone</h1>
      </div>
    </div>
  );
}
